import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero/Hero'

import Cards from './components/Cards'

const ContactView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Twilio Segment Contact Us | Twilio Segment"
        pageDescription="Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data."
      >
        <Navigation />
        <Main>
          <Hero />
          <Cards />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default ContactView
